module.exports = __webpack_public_path__ + "static/img/SFU老师_张博.6b0f162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_张博.png
// module id = kxmH
// module chunks = 0